import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DashboardComponent } from './dashboard/dashboard.component';
import { DesignListComponent } from './entryForm/DesignList/DesignList.component';

const routes: Routes = [
    { path: '', component: DesignListComponent },
    { path: 'pages', loadChildren: () => import('./utility/utility.module').then(m => m.UtilityModule) },
    { path: 'form', loadChildren: () => import('./form/form.module').then(m => m.FormModule) },
    { path: 'master', loadChildren: () => import('./masterForm/masterForm.module').then(m => m.MasterFormModule) },
    { path: 'entry', loadChildren: () => import('./entryForm/entryForm.module').then(m => m.EntryFormModule) },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PagesRoutingModule { }
